import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import * as actions from '../../actions';

@Injectable()
export class DeleteEffects {
  public deleteProductList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.deleteProductList),
      map(({ id }) => actions.bulkDeleteLists({ ids: [id] })),
    ),
  );

  constructor(private actions$: Actions) {}
}
